'use client';
import { FunctionComponent } from 'react';
import { t } from '@xFrame4/common/Utils';
import ContactInfoItem from './ContactInfoItem';
import AppTracker from '@components/tracking/AppTracker';

export interface ContactInfoEmailContactProps
{
    email: string;
    language: string;
    emailSubject?: string;
    className?: string;
}

/**
 * Component: displays email contact information
 */
const ContactInfoEmailContact: FunctionComponent<ContactInfoEmailContactProps> = (props) =>
{
    const { email, language, emailSubject } = props;

    if (!email) return null;

    /** Render email content */
    const cmpEmailContent = (
        <a 
            href={emailSubject ? `mailto:${email}?subject=${encodeURIComponent(emailSubject)}` : `mailto:${email}`} 
            className="text-decoration-none"
            onClick={() => AppTracker.trackEmailClick()}
        >
            {email}
        </a>
    );

    /** Render */
    return (
        <ContactInfoItem
            icon="fas fa-envelope"
            title={t('EMAIL', language)}
            valueContent={cmpEmailContent}
            className={props.className}
        />
    );
}

export default ContactInfoEmailContact; 